export const PRODUCT_TO_EDIT = 'PRODUCT_TO_EDIT'

export const MUT_SET_PRODUCT_TO_EDIT = 'MUT_SET_PRODUCT_TO_EDIT'
export const GET_PRODUCT_TO_EDIT = 'GET_PRODUCT_TO_EDIT'

export const NAMESPACE = 'product'
